<template>
    <div>
        <v-stepper value="1">
            <v-stepper-header>
                <v-stepper-step step="1">Détails préliminaires</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="2">Ajouter le responsable et l'organisateur de
                    l'évènement</v-stepper-step>

            </v-stepper-header>
        </v-stepper>

        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">{{
            snackbar_message
        }}</v-snackbar>

        <div v-if="!event" class="text-center">
            <br />
            <br />
            <v-progress-circular color="primary" indeterminate :size="50"></v-progress-circular>
        </div>

        <div v-else>
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="editEvent1()" class="mt-3">
                <v-card flat>
                    <v-card-title>
                        <h6 class="primary--text">
                            Informations sur l'activité
                        </h6>
                    </v-card-title>

                    <v-card-text>
                        <v-container fluid>
                            <v-layout row wrap align-center>
                                <v-flex xs6 sm4>
                                    <v-subheader>Nom de l'évènement</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-text-field v-model="event.name" :rules="nameRules" label="Nom de l'évènement"
                                        clearable solo></v-text-field>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Objectif de l'évènement</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-text-field v-model="event.objective" :rules="objectiveRules"
                                        label="Objectif de l'évènement" clearable solo></v-text-field>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Type d'évènement</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-select v-model="event.event_type_id" :items="types" item-text="name"
                                        item-value="id" item-key="id" @change="loadThematics()"
                                        :rules="[v => !!v || 'Type requis']" label="Type" clearable solo></v-select>
                                </v-flex>
                                <v-flex xs6 sm4 v-if="event.event_type && selectedType && filteredThematics.length > 0">
                                    <v-subheader>Thématique de formation </v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8 v-if="event.event_type && selectedType && filteredThematics.length > 0">
                                    <v-select v-model="event.thematic_type_id" :items="filteredThematics"
                                        item-text="name" item-value="id" item-key="id" label="Thématique" clearable
                                        solo></v-select>
                                </v-flex>

                                <!-- <v-flex xs6 sm4>
                  <v-subheader>MOV</v-subheader>
                </v-flex>
                <v-flex xs6 sm8>
                  <v-text-field v-model="event.mov" :rules="movRules" label="MOV" clearable solo></v-text-field>
                </v-flex> -->

                                <v-flex xs6 sm4>
                                    <v-subheader>Chaine de valeur</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-select v-model="event.chain_ids" :items="value_chains" item-text="name"
                                        item-value="id" :rules="[
                                            v =>
                                                !!v ||
                                                'Chaine de valeur requise'
                                        ]" label="Chaine de valeur" clearable solo chips multiple></v-select>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Domaine</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-select v-model="event.domain_id" :items="domains" item-text="name"
                                        item-value="id" :rules="[v => !!v || 'Domaine requis']" label="Domaine"
                                        clearable solo></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>

                <v-card class="mt-5" flat>
                    <v-card-title>
                        <h6 class="primary--text">Date et lieu de tenu</h6>
                    </v-card-title>

                    <v-card-text>
                        <v-container fluid>
                            <v-layout row wrap align-center>
                                <v-flex xs6 sm4>
                                    <v-subheader>Pays</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-autocomplete v-model="event.country_id" :items="countries" item-text="name"
                                        item-value="id" :rules="[v => !!v || 'Pays requis']" label="Pays" clearable
                                        solo></v-autocomplete>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Département</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-autocomplete v-model="event.department_id" :items="departments" item-text="name"
                                        item-value="id" :rules="[
                                            v => !!v || 'Département requis'
                                        ]" label="Département" clearable solo></v-autocomplete>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Commune</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-autocomplete v-model="event.municipality_id" :items="municipalities"
                                        item-text="name" item-value="id" :rules="[v => !!v || 'Commune requise']"
                                        label="Commune" clearable solo></v-autocomplete>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Arrondissement</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-autocomplete v-model="event.district_id" :items="districts" item-text="name"
                                        item-value="id" :rules="[
                                            v => !!v || 'Arrondissement requis'
                                        ]" label="Arrondissement" clearable solo></v-autocomplete>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Village</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-autocomplete v-model="event.town_id" :items="towns" item-text="name"
                                        item-value="id" :rules="[v => !!v || 'Village requis']" label="Village"
                                        clearable solo></v-autocomplete>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Date</v-subheader>
                                </v-flex>
                                <v-flex xs4 sm4>
                                    <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field :value="eventDateMoment" clearable label="Date de l'évènement"
                                                readonly v-on="on" prepend-icon="mdi-calendar" solo></v-text-field>
                                        </template>
                                        <v-date-picker v-model="event.event_date" :min="allowedDateStart"
                                            @input="menu1 = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs3 sm3 offset-xs1>
                                    <v-menu v-model="menu3" :close-on-content-click="false" max-width="290">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field :value="eventDateEndMoment" clearable label="Date de fin"
                                                readonly v-on="on" solo></v-text-field>
                                        </template>
                                        <v-date-picker v-model="event.event_date_end" :min="allowedDateEnd"
                                            @input="menu3 = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Heure</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                        :return-value.sync="time" transition="scale-transition" offset-y
                                        max-width="290px" min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="time" label="Heure de l'évènement"
                                                prepend-icon="mdi-timetable" v-on="on" solo clearable></v-text-field>
                                        </template>
                                        <v-time-picker v-if="menu2" v-model="time" format="24hr" @click:minute="
                                            $refs.menu.save(time)
                                            " solo></v-time-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs6 sm4>
                                    <v-subheader>Lieu</v-subheader>
                                </v-flex>
                                <v-flex xs6 sm8>
                                    <v-text-field v-model="event.place" :rules="placeRules" label="Lieu" clearable
                                        solo></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions></v-card-actions>
                </v-card>

                <div class="text-center mt-3">
                    <v-btn rounded color="info" :loading="loadingSave" :disabled="loadingSave"
                        @click="saveEndClose()">Enregistrer et
                        quitter</v-btn>
                    <v-btn rounded color="primary" type="submit">Suivant</v-btn>
                    <br />
                    <br />
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Permissions from '~/mixins/Permissions'
export default {
    name: "edit-event",
    mixins: [Permissions],
    data: () => ({
        valid: false,
        nameRules: [v => !!v || "Nom requis"],
        objectiveRules: [v => !!v || "Objectif de l'évènement requis"],
        // movRules: [v => !!v || "MOV requis"],
        placeRules: [v => !!v || "Lieu de l'évènement requis"],
        event_date: null,
        event_date_end: null,
        menu1: false,
        menu2: false,
        menu3: false,
        time: null,
        snackbar: false,
        snackbar_message: "",
        snackbar_timeout: 5000,
        snackbar_color: "",
        event: {},
        selectedType: null,
        loadingSave: false,
        showOkok: false,

    }),

    computed: {
        // getEvent() {
        //     const item = JSON.parse(
        //         JSON.stringify(this.$store.getters.getEditableEvent)
        //     );
        //     this.event = item;
        //     let tab = item.event_date.split(" ");
        //     this.event_date = tab[0];
        //     this.time = tab[1];
        //     return item;
        // },

        tab_chain_ids() {
            let tab = JSON.parse(
                JSON.stringify(this.$store.getters.getEditableEvent.chains)
            );
            let resultat = [];
            tab.forEach(function (item) {
                resultat.push(item.id);
            });
            return resultat;
        },

        value_chains() {
            return this.$store.getters.getValueChains;
        },
        domains() {
            return this.$store.getters.getDomains;
        },
        types() {
            return this.$store.getters.event_types;
        },

        countries() {
            return this.$store.getters.getCountries;
        },
        departments() {
            return this.$store.getters.departments;
        },
        municipalities() {
            return this.$store.getters.municipalities;
        },
        districts() {
            return this.$store.getters.districts;
        },
        towns() {
            return this.$store.getters.towns;
        },
        filteredThematics: {
            // getter
            get: function () {
                if (this.event.event_type_id == null || this.selectedType == null) {
                    return this.$store.getters.thematic_types
                } else {
                    return this.$store.getters.thematic_types.filter(thematic => thematic.event_type_id === this.selectedType.id)
                }

            },
        },
        eventDateMoment() {
            return this.event.event_date
                ? this.$moment(this.event.event_date).format("D MMMM YYYY")
                : "";
        },

        eventDateEndMoment() {
            return this.event.event_date_end
                ? this.$moment(this.event.event_date_end).format("D MMMM YYYY")
                : "";
        },
        allowedDateStart() {
            let aujourdhui = this.$moment(new Date()).format("YYYY-MM-DD");
            return aujourdhui;
        },

        allowedDateEnd() {
            let aujourdhui = this.$moment(new Date()).format("YYYY-MM-DD");
            return aujourdhui;
        }
    },

    created() {
        this.$checkPermission('edit events')
        this.fetchUtils();
    },

    mounted() {
        this.checkRegistering();
    },

    methods: {
        fetchUtils() {
            this.$store.dispatch("loadCountries");
            this.$store.dispatch("fetchEventTypes");
            this.$store.dispatch("loadValueChains");
            this.$store.dispatch("loadDomains");
            this.$store.dispatch("fetchDepartments");
            this.$store.dispatch("fetchMunicipalities");
            this.$store.dispatch("fetchDistricts");
            this.$store.dispatch("fetchTowns");
            this.$store.dispatch("fetchThematicTypes");
        },
        loadThematics() {
            // const eventName = this.event.event_type ? this.event.event_type.name :'';
            // this.selectedType = this.types.find(type => type.name === eventName);

            this.selectedType = this.types.find(type => type.id === this.event.event_type_id);

        },
        checkRegistering() {
            const item = JSON.parse(
                JSON.stringify(this.$store.getters.getEditableEvent)
            );

            if (item != null) {
                this.event = item;
                this.event.chain_ids = this.tab_chain_ids;

                // this.event_date = item.event_date;
                // this.event_date_end = item.event_date_end;
                this.time = item.event_time;

                this.loadThematics()
            }
        },

        /*chooseDepartement(){
      let pays = this.event.country_id;
      this.$store.dispatch('loadDepartments', pays);
    },

    chooseMunicipality(){
      let departement = this.event.department_id;
      this.$store.dispatch('loadMunicipalities', departement);
    },

    chooseDistrict(){
      let commune = this.event.municipality_id;
      this.$store.dispatch('loadDistricts', commune);
    },

    chooseTown(){
      let arrond = this.event.district_id;
      this.$store.dispatch('loadTowns', arrond);
    },*/

        editEvent1() {
            // this.event.event_date = this.event_date;
            // this.event.event_date_end = this.event_date_end;
            this.event.event_time = this.time;
            if (
                !this.event.name ||
                !this.event.objective ||
                !this.event.event_type_id ||
                !this.event.chain_ids ||
                !this.event.domain_id ||
                !this.event.event_date ||
                !this.event.event_date_end ||
                !this.time ||
                !this.event.place ||
                !this.event.country_id ||
                !this.event.department_id ||
                !this.event.municipality_id ||
                !this.event.district_id ||
                !this.event.town_id
            ) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message =
                    "Veuillez remplir tous les champs avant de poursuivre";
                return;
            }
            const eventDate = this.event.event_date.split(" ")[0];
            if (this.event.event_date_end < eventDate) {
                this.snackbar = true
                this.snackbar_color = 'error'
                this.snackbar_message = "La date de fin ne peut pas être antérieure à la date de début.";
                return;
            }
            this.$store.dispatch("updateEvent1", this.event);
            this.$router.push({
                name: "events.edit-2",
                params: { first_next: true }
            });

        },

        checkInput() {

        },

        async saveEndClose() {

            this.event.event_time = this.time;
            if (
                !this.event.name ||
                !this.event.objective ||
                !this.event.event_type_id ||
                !this.event.chain_ids ||
                !this.event.domain_id ||
                !this.event.event_date ||
                !this.event.event_date_end ||
                !this.time ||
                !this.event.place ||
                !this.event.country_id ||
                !this.event.department_id ||
                !this.event.municipality_id ||
                !this.event.district_id ||
                !this.event.town_id
            ) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message =
                    "Veuillez remplir tous les champs avant de poursuivre";
                return;
            }
            const eventDate = this.event.event_date.split(" ")[0];
            if (this.event.event_date_end < eventDate) {
                this.snackbar = true
                this.snackbar_color = 'error'
                this.snackbar_message = "La date de fin ne peut pas être antérieure à la date de début.";
                return;
            }
            this.loadingSave = true;
            this.$store.dispatch("updateEvent1", this.event);
            await this.$store.dispatch("updateEvent").then(value => {
                if (value == true) {
                    const now = new Date();
                    const start = new Date(this.event.event_date);
                    const end = new Date(this.event.event_date_end);

                    if (now >= start && now <= end) {
                        this.$router.push({
                            name: "events.in_progress",
                            params: { event_updated: value }
                        });
                    }
                    else if (now < end) {
                        this.$router.push({
                            name: "events.coming",
                            params: { event_updated: value }
                        });
                    } else if (now > start) {
                        this.$router.push({
                            name: "events.past",
                            params: { event_updated: value }
                        });
                    } else {
                        this.$router.push({
                            name: "events.in_progress",
                            params: { event_updated: value }
                        });
                    }

                    this.loadingSave = false;
                } else {
                    console.log("Something went wrong!");
                }
            });

        }
    }
};
</script>

<style scoped>
.theme--light.v-subheader {
    font-size: 1.3em;
    color: black;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/edit-1.vue